<template>
  <SearchShops />
</template>
<script>
import SearchShops from '@/components/locations/SearchShops.vue'
export default {
  name: 'SearchShopsView',
  components: {
    SearchShops
  }
}
</script>
<style lang="scss" scoped></style>
